import React, { useEffect, useState } from "react";
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { Form, Col, Row, Card, CardBody, Button, Container } from "react-bootstrap";
import setting from "../../setting.json";
import schools from '../../constants/schools.json';
import { Link, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import { useFieldArray } from 'react-hook-form';
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";


const schema = yup.object().shape({
    profile: yup.string().required("Please enter Name"),

});

function CareerConfirmation() {

    const location = useLocation();
    const { application } = location.state || {};


    //   let application = useParams();
    //   console.log(application);


    const [msg, setMsg] = useState();
    const [show, setShow] = useState(false);
    const navigate = useNavigate();









    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [subDistrictList, setSubDistrictList] = useState([]);




    const getAllState = async () => {

        await fetch(setting.api + 'student/getAllState', {
            method: "GET",
            mode: "cors",
        })
            .then(response => response.json())
            .then(sd => {
                setStateList(sd.data);
            });
    }



    useEffect(() => {

        getAllState();
    }, []);









    return (

        <div className="student-page">
            <Header />
            <header className="height-75">
                <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
                    <h1 className="text-center fw-semibold"> Career Form</h1>
                </div>
            </header>




            <Container className="mt-5 mb-5" style={{ maxWidth: '600px' }}>
                <Card className="p-4 shadow">
                    <h5 className="mb-3 text-success">
                        ✅ Application Submitted Successfully!
                    </h5>

                    <p>
                        Thank you for applying to <strong>Acharya Chanakya Mahavidyalaya</strong>.
                        <br />
                        Your application has been received and registered successfully.
                    </p>

                    <p>

                        <strong>Your Application Number: </strong> {application?.id}<br />
                        <strong>Interview Date:</strong> 13 August 2025 (Wednesday)<br />
                        <strong>Time:</strong> From <strong>10:00 AM</strong> onwards<br />
                        <strong>Venue:</strong> Acharya Chanakya Mahavidyalya, Mahmoodpur, Semari, Sultanpur, UP 228142
                    </p>

                    <p>
                        Please <strong>keep your reference number safe</strong> for all future communication.
                    </p>

                    <p>
                        For any queries, contact us at: <br />
                        <strong>[office.acmcollege@gmail.com]</strong>
                    </p>

                    <p>We look forward to meeting you.<br />Best of luck!</p>
                </Card>
            </Container>


            {/* <div className="container my-5">
                <div className="row">
                    <div className="col-lg-12 d-flex flex-column text-align-justify justify-content-center mb-4 mb-lg-0">
                        <h2 className="mb-4 mb-lg-5" >
                            <h2>Application Submitted Successfully!</h2>
                            <span>Thank you for applying to Acharya Chanakya Mahavidyalya.
Your application has been received and registered successfully.
</span>

                        </h2>

                    </div>


                </div>
            </div> */}
            <Footer />
        </div>
    );
}

export default CareerConfirmation;
